import React from "react";

import type { SxProps } from "@mui/material";

import AddReadInput from "@app/analytics/components/AddReadInput";
import useAddRead from "@app/analytics/hooks/meetings/useAddRead";
import { toast } from "@app/common/hooks/useToasts";

const INPUT_STYLE_OVERRIDES: SxProps = {
  width: "240px",
  minWidth: "240px",
  "& .MuiInputBase-root": { height: "40px" },
  input: { fontSize: "0.875rem" },
  "& .MuiInputAdornment-positionEnd .MuiButton-root": {
    height: "34px",
  },
};

const handleValidationFail = () =>
  toast.error("Please input a valid https URL");

const CalendarAddRead = () => {
  const { addRead, hasInputError, meetingUrl, onInputChange, reset, validate } =
    useAddRead({
      onValidationFail: handleValidationFail,
      uiLocation: "calendar",
    });

  const handleAddRead = () => {
    const isValid = validate(meetingUrl);
    if (isValid) {
      addRead.mutate(
        { meetingUrl },
        {
          onSuccess: () => {
            toast.success("Success! Read has been added to your meeting.");
            reset();
          },
          onError: () => {
            toast.error(
              "Read was unable to join the meeting URL provided. Please check the URL and try again."
            );
          },
        }
      );
    }
  };

  return (
    <AddReadInput
      error={hasInputError || addRead.isError}
      value={meetingUrl}
      loading={addRead.isPending}
      onChange={onInputChange}
      onSubmit={handleAddRead}
      placeholder="Add Read to a live meeting"
      sx={INPUT_STYLE_OVERRIDES}
    />
  );
};

export default CalendarAddRead;
